import React from 'react';
import PropTypes from 'prop-types';
// common components
import AddQuestion from './../../../common/AddQuestion/AddQuestion';

const ManageQuestion = ({
	onDelete, onChange, question, reason, url, options, onChangeOption,
	onCreateOption, onDestroyOption, onToggleCorrectOption
}) => {
	if(onDelete) {
		return (
			<div className='ManageQuestion'>
				<div>Are you sure, you want to delete?</div>
			</div>
		);
	};
	return (
		<div className='ManageQuestion'>
			<AddQuestion
                onChange={(e) => onChange(e)}
                question={question}
                options={options}
				reason={reason}
				url={url}
                onChangeOption={onChangeOption}
                onToggleCorrectOption={onToggleCorrectOption}
                onCreateOption={onCreateOption}
				onDestroyOption={onDestroyOption}
            />
		</div>
	);
}

ManageQuestion.propTypes = {
	onDelete: PropTypes.bool,
	onChange: PropTypes.func,
	question: PropTypes.string,
	reason: PropTypes.string,
	url: PropTypes.string,
	options: PropTypes.instanceOf(Array),
	onChangeOption: PropTypes.func,
	onCreateOption: PropTypes.func,
	onDestroyOption: PropTypes.func,
    onToggleCorrectOption: PropTypes.func
};

ManageQuestion.defaultProps = {
	onDelete: false,
	onChange: () => {},
	question: '',
	reason: '',
	url: '',
	options: [],
	onChangeOption: () => {},
	onCreateOption: () => {},
	onDestroyOption: () => {},
    onToggleCorrectOption: () => {}
};

export default ManageQuestion;



// WEBPACK FOOTER //
// ./components/ModuleQuestion/ManageQuestion/ManageQuestion.js